import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const AtlantaIcon = ()=>/*#__PURE__*/ _jsxs("svg", {
        width: "15",
        height: "36",
        viewBox: "0 0 15 36",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("g", {
                "clip-path": "url(#clip0_1793_2742)",
                children: /*#__PURE__*/ _jsx("path", {
                    d: "M7.02344 0.0771484V1.51855L7.21484 1.74609V1.77734H7.44434L11 8.88867V35.5557H3V8.88867L6.55566 1.77734H6.70508V1.74609L6.89453 1.51855V0.0771484L6.95801 0H6.95996L7.02344 0.0771484Z",
                    fill: "#8BC3FC"
                })
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "clip0_1793_2742",
                    children: /*#__PURE__*/ _jsx("rect", {
                        width: "15",
                        height: "36",
                        fill: "white"
                    })
                })
            })
        ]
    });
